import { cardItems } from '@/mocks/homeData';

export default function InfoCards() {
  return (
    <section id="cards" className="py-12 md:py-16 bg-white">
      <div className="section-container">
        <div className="text-center mb-8 md:mb-12">
          <h2 className="section-title">吃瓜快讯</h2>
          <p className="section-subtitle">最新最热吃瓜资讯，一网打尽今日大瓜</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {cardItems.map((item) => (
            <article
              key={item.id}
              className="group bg-white rounded-xl border border-background-200 hover:border-primary-200 overflow-hidden transition-all hover:shadow-sm cursor-pointer flex flex-col"
            >
              <div className="relative aspect-[16/10] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3 flex gap-2">
                  <span className="bg-primary-500 text-white text-xs font-medium px-2.5 py-1 rounded-full">
                    {item.category}
                  </span>
                  <span className="bg-accent-500 text-white text-xs font-medium px-2.5 py-1 rounded-full">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5 flex-1 flex flex-col">
                <h3 className="text-base md:text-lg font-bold text-foreground-950 group-hover:text-primary-500 transition-colors line-clamp-2 leading-snug">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500 mt-2 line-clamp-3 leading-relaxed flex-1">
                  {item.description}
                </p>
                <div className="flex items-center justify-between mt-4 pt-3 border-t border-background-100">
                  <span className="text-xs text-foreground-400 flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    {item.date}
                  </span>
                  <span className="text-xs text-primary-500 font-medium flex items-center gap-1 cursor-pointer hover:text-primary-600 transition-colors">
                    阅读全文
                    <i className="ri-arrow-right-line text-xs"></i>
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}